import React, { FC } from 'react';

import { ErrorLoadPageIcon } from '@evinced-private/ui-common';

import { LoadErrorMsgLayout } from '../../../pages/property/LoadErrorMsgLayout';

import { EvPropertyViews } from './EvPropertyViews';

import './PropertyViewLoadErrorPage.scss';

const mainTitle = 'The selected view isn’t available';
const secondaryMsg = 'Try switching to a different view.';

interface IPropertyViewLoadErrorPage {
	propertyId: string;
}

export const PropertyViewLoadErrorPage: FC<IPropertyViewLoadErrorPage> = ({ propertyId }) => {
	return (
		<div className="wrapper">
			<div className="header">
				<EvPropertyViews propertyId={propertyId} />
			</div>
			<LoadErrorMsgLayout
				mainTitle={mainTitle}
				secondaryMsg={secondaryMsg}
				icon={ErrorLoadPageIcon}
			/>
		</div>
	);
};
